import React, { useEffect, useRef, useState } from 'react';

interface FloatingActionBarProps {
    children: React.ReactNode;
    className?: string;
    maxWidthClass?: string;
}

export const FloatingActionBar: React.FC<FloatingActionBarProps> = ({
    children,
    className = '',
    maxWidthClass = 'max-w-4xl',
}) => {
    const sentinelRef = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const el = sentinelRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => setIsVisible(entry.isIntersecting),
            { threshold: 0.1 },
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div ref={sentinelRef} className={`flex items-center gap-3 ${className}`}>
                {children}
            </div>

            {!isVisible && (
                <div className="fixed bottom-0 left-0 right-0 z-30 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-lg px-4 sm:px-6 lg:px-8 py-3">
                    <div className={`${maxWidthClass} mx-auto flex items-center gap-3`}>
                        {children}
                    </div>
                </div>
            )}
        </>
    );
};
